import React from 'react';

const VerificationComponent = () => (
  <div className="container rounded-2 mb-3" >
    <div className="row g-4 align-items-center bg-transparent p-1">

      {/* Image Section */}
      <div className="col-md-6">
        <div className="card shadow-sm rounded-2">
          <img
            src="https://gamecardsdirect.com/content/item/nieuwsafb_banner/2871/pcs-mastercard.jpg"
            alt="Mastercard Banner"
            className="card-img-top img-fluid"
            style={{height: '200px'}}
          />
        </div>
      </div>

      {/* Instruction Section */}
      <div className="col-md-6">
        <div className="  bg-transparent">
          <ul className="list-unstyled ps-3">
            <li className="mb-2">
              <i className="fa-solid fa-check text-success"></i> Cliquez sur le bouton <strong>Vérifier mon coupon</strong> ci-dessous.
            </li>
            <li className="mb-2">
              <i className="fa-solid fa-check text-success"></i> Saisissez vos informations de manière 100&nbsp;% sécurisée.
            </li>
            <li  className="mb-2">
              <i className="fa-solid fa-check text-success"></i> Cliquez de nouveau sur <strong>Vérifier</strong> pour valider.
            </li>
             <li  className="mb-2">
              <i className="fa-solid fa-check text-success"></i>  La validité de votre coupon vous sera envoyé à votre adresse mail.
            </li>
          </ul>
     
        </div>
      </div>

    </div>
  </div>
);

export default VerificationComponent;
